import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy } from '@angular/core';
import { fadeInAnimation, fadeOutAnimation, zoomInAnimation, zoomOutAnimation } from 'angular-animations';
import { SharedService } from '../../services/shared.service';
import { VeNewsFeed } from '../../typings';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrl: './qr-code.component.scss',
  standalone: false,
  animations: [
    trigger('fadeInOut', [
      state('in', style({
        opacity: 1, transform: 'scale(1) translateY(0%)'
      })),
      state('out', style({
        opacity: 0, transform: 'scale(0.5) translateY(100%)'
      })),
      transition('in <=> out', [
        animate('500ms')
      ]),
    ]),
    fadeInAnimation(),
    fadeOutAnimation(),
    zoomInAnimation(),
    zoomOutAnimation()
  ]
})
export class QrCodeComponent  implements OnDestroy {
  private destroy$ = new Subject<void>();
  public currentNews: any;
  public animationStateIn = false;
  public animationStateOut = false;
  public qrCodeSize = 140;
  private newValue: VeNewsFeed;
  public animationQRCodeStateOut = false;
  public mobileUrl = '';

  private videoTimeoutId?: number;

  constructor(private sharedService: SharedService) {
    this.sharedService.getConfiguration()
      .pipe(takeUntil(this.destroy$))
      .subscribe(config => {
        this.mobileUrl = config.mobileUrl;
      });
    this.sharedService.videoEnded$
      .pipe(takeUntil(this.destroy$))
      .subscribe(video => {
        this.animationQRCodeStateOut = false;
      });
  }

  public setInitialValue(v: VeNewsFeed) {
    this.qrCodeSize = document.documentElement.clientWidth / 100 * 8;
    this.currentNews = v;

    if (this.sharedService.isVideo(this.currentNews)) {
      this.videoTimeoutId = window.setTimeout(() => {
        this.animationQRCodeStateOut = true;
      }, (5000));
    }
  }

  public getUrl(url:string):string
  {
    return this.mobileUrl + "home" + url;
  }

  public changeValue(v: VeNewsFeed) {
    this.clearVideoTimeout();
    this.animationQRCodeStateOut = false;
    this.newValue = v;
    this.animationStateOut = true;
    (document.getElementById("borderAnimationTop") as HTMLDivElement).classList.remove("borderAnimationTop");
    (document.getElementById("borderAnimationRight") as HTMLDivElement).classList.remove("borderAnimationRight");
    (document.getElementById("borderAnimationBottom") as HTMLDivElement).classList.remove("borderAnimationBottom");
    (document.getElementById("borderAnimationLeft") as HTMLDivElement).classList.remove("borderAnimationLeft");

    if (this.sharedService.isVideo(this.newValue)) {
      this.videoTimeoutId = window.setTimeout(() => {
        this.animationQRCodeStateOut = true;
      }, (6000));
    }
  }

  public animOutDone() {
    if (this.newValue) {
      this.currentNews = this.newValue;
      this.animationStateOut = false;
      this.animationStateIn = true;
      if((document.getElementById("borderAnimationTop") as HTMLDivElement))
      {
        (document.getElementById("borderAnimationTop") as HTMLDivElement).classList.add("borderAnimationTop");
        (document.getElementById("borderAnimationRight") as HTMLDivElement).classList.add("borderAnimationRight");
        (document.getElementById("borderAnimationBottom") as HTMLDivElement).classList.add("borderAnimationBottom");
        (document.getElementById("borderAnimationLeft") as HTMLDivElement).classList.add("borderAnimationLeft");
      }
    }
  }

  public animInDone() {
    this.animationStateIn = false;
  }

  private clearVideoTimeout(): void {
    if (this.videoTimeoutId) {
      window.clearTimeout(this.videoTimeoutId);
      this.videoTimeoutId = undefined;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.clearVideoTimeout();
  }
}

